// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3GVlN","log":"ModalInventoryLogs_log__3IMhS","date":"ModalInventoryLogs_date__1c7kI","userName":"ModalInventoryLogs_userName__1t_8J"};